export { SmallRatings } from "./SmallRatings"
